require('../fhApp/appMetaService');

"use strict";

angular.module('app.promo.promoController', [
  'app.appMetaService'
])
  .controller('app.promo.promoController', [
    '$scope','$http', 'STRIPE_PUBLIC_KEY', 'appMetaService',
    function ($scope, $http, stripePublicKey, appMeta) {
      $scope.appMeta = appMeta;

      //true to show offer and false for successful payment
      $scope.showOffer = true;


      //turn off Buy button on Dec 24th at 2pm
      $scope.showPromoBtn = () => {
        let showBuyBtn = false;
        let today = new Date();
        let endDate = new Date('2018-12-24T14:00:00');
        if (today <= endDate) {
          showBuyBtn = true;
        }
        return showBuyBtn;
      };

      var handler = StripeCheckout.configure({
        key: stripePublicKey,
        image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
        locale: 'auto',
        token: function(token) {
          var postData = {
            "stripeToken": token.id,
            "stripeEmail": token.email,
            "stripeName": token.card.name
          };

          // Make the call to the API to make the payment
          $http.post(window.location.api('subscriptions/stripe'), postData)
          .then(
            // success callback
            function(response) {
              if(response.status >= 200 && response.status <= 299) {
                $scope.showOffer = false;
              } else {
                alert("Something went wrong with your payment. Please refresh this page and try again later.");
              }
            },
            // error callback
            function(response) {
              alert("Something went wrong with your payment. Please refresh this page and try again later.");
           }
          );          
        }
      });

      $scope.openStripeHandler = function($event) {
        // Open Checkout with further options:
        handler.open({
          name: 'HockeyTech USA LLC',
          description: 'HockeyTV Christmas Gift Subscription',
          amount: 5999,
          billingAddress: true,
          zipCode: true
        });
        $event.preventDefault();
      };

      // Close Checkout on page navigation:
      window.addEventListener('popstate', function() {
        handler.close();
      });

    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/promo/promoController.js